import api from "core/api";
import asyncThunk from "core/decorators/toolkit";

export const getActionsOpportunities = asyncThunk(
  "panel/projects/actionsOpportunities",
  api.project.getActionsOpportunities
);
